// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2GQMG","header":"PatientBlock_header__1lU0h","label":"PatientBlock_label__2zHGc","option":"PatientBlock_option__1xclv"};